import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Form, Input, Icon, notification, Select, Spin, Modal, Button } from "antd";
import { GlobalContext } from "../../../app/providers/GlobalState";
import axios from "axios";
import moment from "moment";

const confirm = Modal.confirm;
const { Option } = Select;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class Conteudos extends Component {
    static contextType = GlobalContext;

    state = {
        bncc: [],
        conteudo: "",
        conceitos: undefined,
        metodologia: "",
        aprendizagemMatutino: "",
        aprendizagemVespertino: "",
        conteudoOriginal: "",
        conceitosOriginal: undefined,
        metodologiaOriginal: "",
        aprendizagemMatutinoOriginal: "",
        aprendizagemVespertinoOriginal: "",
        bloquearAutoSave: true,
        campoConteudos: null,
        campoHabilidades: null,
        campoMetodologia: null,
        campoAprendizagemMatutina: null,
        campoAprendizagemVespertina: null,
        //LOADING
        iconLoading: false,
        searchValue: "",
        filteredData: [],
        loading: false,
        page: 1,
        semMaisDados: false
    };

    componentDidMount() {
        this.carregarConteudoAula();
        this.carregarTitulosPersonalizados();
        this.carregarHabilidadesBncc();
    }

    ultimoAulaDiario = localStorage.getItem("aula_diario");

    componentDidUpdate(prevProps, prevState) {
        const aulaDiarioAtual = localStorage.getItem("aula_diario");

        if (this.ultimoAulaDiario !== aulaDiarioAtual) {
            this.setState(
                {
                    bloquearAutoSave: true,
                    conteudo: "",
                    conceitos: undefined,
                    metodologia: "",
                    aprendizagemMatutino: "",
                    aprendizagemVespertino: ""
                },
                () => {
                    this.carregarConteudoAula();
                    this.carregarTitulosPersonalizados();
                    this.carregarHabilidadesBncc();
                    this.setState({ bloquearAutoSave: false });
                }
            );

            this.ultimoAulaDiario = aulaDiarioAtual;
        }

        if (this.props.sumarioExcluido) {
            this.props.form.resetFields();
            this.setState({
                conteudo: "",
                conceitos: undefined,
                metodologia: "",
                aprendizagemMatutino: "",
                aprendizagemVespertino: ""
            });
            this.props.resetSumarioExcluido();
        }

        const conteudoMudou =
            prevState.conteudo !== this.state.conteudo ||
            prevState.conceitos !== this.state.conceitos ||
            prevState.metodologia !== this.state.metodologia ||
            prevState.aprendizagemMatutino !== this.state.aprendizagemMatutino ||
            prevState.aprendizagemVespertino !== this.state.aprendizagemVespertino;

        if (conteudoMudou) {
            clearTimeout(this.autoSaveTimeout);

            this.autoSaveTimeout = setTimeout(() => {
                const { conteudo, conceitos, metodologia, aprendizagemMatutino, aprendizagemVespertino, bloquearAutoSave } = this.state;

                const tudoVazio =
                    !conteudo?.trim() &&
                    (!conceitos || conceitos.length === 0) &&
                    !metodologia?.trim() &&
                    !aprendizagemMatutino?.trim() &&
                    !aprendizagemVespertino?.trim();

                if (bloquearAutoSave || tudoVazio) return;

                const conteudoIgual = (conteudo || "").trim() === (this.state.conteudoOriginal || "").trim();
                const metodologiaIgual = (metodologia || "").trim() === (this.state.metodologiaOriginal || "").trim();
                const aprendizagemMatutinoIgual =
                    (aprendizagemMatutino || "").trim() === (this.state.aprendizagemMatutinoOriginal || "").trim();
                const aprendizagemVespertinoIgual =
                    (aprendizagemVespertino || "").trim() === (this.state.aprendizagemVespertinoOriginal || "").trim();

                const arraysIguais = (a, b) => {
                    if (!Array.isArray(a) || !Array.isArray(b)) return false;
                    if (a.length !== b.length) return false;
                    const sortedA = [...a].map(s => s.trim()).sort();
                    const sortedB = [...b].map(s => s.trim()).sort();
                    return sortedA.every((val, idx) => val === sortedB[idx]);
                };
                const conceitosIguais = arraysIguais(conceitos || [], this.state.conceitosOriginal || []);

                const semAlteracaoReal =
                    conteudoIgual && metodologiaIgual && conceitosIguais && aprendizagemMatutinoIgual && aprendizagemVespertinoIgual;

                if (semAlteracaoReal) return;

                this.guardarRascunhoAula();
            }, 1000);
        }
    }

    handleChange = event => {
        const { name, value } = event.target;

        const conteudo = name === "conteudo" ? value : this.state.conteudo;
        const metodologia = name === "metodologia" ? value : this.state.metodologia;
        const aprendizagemMatutino = name === "aprendizagemMatutino" ? value : this.state.aprendizagemMatutino;
        const aprendizagemVespertino = name === "aprendizagemVespertino" ? value : this.state.aprendizagemVespertino;

        const tudoVazio =
            !conteudo?.trim() &&
            !metodologia?.trim() &&
            !aprendizagemVespertino?.trim() &&
            !aprendizagemMatutino?.trim() &&
            (!this.state.conceitos || this.state.conceitos.length === 0);

        if (tudoVazio) {
            this.apagarRascunhoAula();
        }

        this.setState({
            [name]: value,
            bloquearAutoSave: tudoVazio
        });

        this.context.atualizarState({
            existeRascunhoGuardado: !tudoVazio
        });
    };

    handleChangeSelect = conceitos => {
        const tudoVazio =
            !this.state.conteudo?.trim() &&
            !this.state.metodologia?.trim() &&
            !this.state.aprendizagemMatutino?.trim() &&
            !this.state.aprendizagemVespertino?.trim() &&
            (!conceitos || conceitos.length === 0);

        if (tudoVazio) {
            this.apagarRascunhoAula();
        }

        this.setState({
            conceitos,
            filteredData: this.state.bncc,
            page: 2,
            bloquearAutoSave: tudoVazio
        });

        this.context.atualizarState({
            existeRascunhoGuardado: !tudoVazio
        });
    };

    handleSearch = searchValue => {
        this.setState({
            searchValue
        });
        if (searchValue) {
            const filtered = this.state.bncc.filter(item => item.toLowerCase().split("-")[0].includes(searchValue.toLowerCase()));

            this.setState({
                filteredData: filtered,
                loading: false,
                page: 2
            });
        } else {
            this.setState({
                filteredData: [],
                loading: false,
                page: 2
            });
        }
    };

    handlePopupScroll = e => {
        const { target } = e;

        if (Math.round(target.scrollTop + target.clientHeight) === Math.round(target.scrollHeight) && !this.state.semMaisDados) {
            this.fetchMoreData();
        }
    };

    guardarConteudoAula = multisseriado => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const { conteudo, conceitos, metodologia, aprendizagemMatutino, aprendizagemVespertino } = values;

                if (conteudo || conceitos?.length > 0 || metodologia || aprendizagemMatutino || aprendizagemVespertino) {
                    this.setState({ iconLoading: true });

                    var item = new FormData();
                    item.append("id", this.props.aulaId);
                    if (conteudo) item.append("conteudo", conteudo);
                    if (conceitos?.length > 0) item.append("conceitos", conceitos.join(";"));
                    if (metodologia) item.append("metodologia", metodologia);
                    if (aprendizagemMatutino) item.append("aprendizagem_matutino", aprendizagemMatutino);
                    if (aprendizagemVespertino) item.append("aprendizagem_vespertino", aprendizagemVespertino);
                    item.append("multisseriado", multisseriado);

                    axios({
                        method: "put",
                        url: "/api/aulas/alterar-conteudo",
                        data: item
                    })
                        .then(response => {
                            openNotificationWithIcon("success", "Sucesso", "Conteúdos da aula alterados!");
                            this.setState({ iconLoading: false });
                            this.context.atualizarState({
                                existeRascunhoGuardado: false
                            });
                            this.props.disponibilizarExcluir();
                        })
                        .catch(error => {
                            openNotificationWithIcon("error", "Erro", "Não foi possível alterar conteúdos da aula!");
                            this.setState({ iconLoading: false });
                        });
                } else {
                    openNotificationWithIcon("error", "Erro", "Não existem dados a serem guardados!");
                }
            }
        });
    };

    guardarRascunhoAula = async () => {
        const { conteudo, conceitos, metodologia, aprendizagemMatutino, aprendizagemVespertino } = this.state;
        const aulaId = localStorage.getItem("aula_diario");

        if (!aulaId) return;

        const item = new FormData();
        item.append("id", aulaId);
        item.append("conteudo", conteudo || "");
        item.append("conceitos", conceitos && conceitos.length > 0 ? conceitos.join(";") : "");
        item.append("metodologia", metodologia || "");
        item.append("aprendizagem_matutino", aprendizagemMatutino || "");
        item.append("aprendizagem_vespertino", aprendizagemVespertino || "");

        axios({
            method: "put",
            url: "/api/aulas/rascunho",
            data: item
        })
            .then(() => {
                this.context.atualizarState({
                    existeRascunhoGuardado: true
                });
            })
            .catch(() => {
                openNotificationWithIcon(
                    "error",
                    "Erro ao guardar",
                    "Ocorreu um problema ao guardar o rascunho dos conteúdos. Tente novamente."
                );
                this.setState({ iconLoading: false });
                this.context.atualizarState({
                    existeRascunhoGuardado: false
                });
            });
    };

    carregarConteudoAula = () => {
        axios({
            method: "get",
            url: "/api/aulas/detalhe-conteudo",
            params: {
                aulaId: localStorage.getItem("aula_diario")
            }
        })
            .then(response => {
                const conteudo = response.data.conteudo || "";
                const conceitos = response.data.conceitos ? response.data.conceitos.split(";") : undefined;
                const metodologia = response.data.metodologia || "";
                const aprendizagemMatutino = response.data.aprendizagem_matutino || "";
                const aprendizagemVespertino = response.data.aprendizagem_vespertino || "";

                this.setState(
                    {
                        conteudo,
                        conceitos,
                        metodologia,
                        aprendizagemMatutino,
                        aprendizagemVespertino,
                        conteudoOriginal: conteudo,
                        conceitosOriginal: conceitos,
                        metodologiaOriginal: metodologia,
                        aprendizagemMatutinoOriginal: aprendizagemMatutino,
                        aprendizagemVespertinoOriginal: aprendizagemVespertino
                    },
                    () => {
                        this.props.form.setFieldsValue({
                            conteudo,
                            conceitos,
                            metodologia,
                            aprendizagemMatutino,
                            aprendizagemVespertino
                        });
                        this.carregarRascunhoAula(conteudo, conceitos, metodologia, aprendizagemMatutino, aprendizagemVespertino);
                    }
                );
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar a aula!");
            });
    };

    carregarTitulosPersonalizados = () => {
        axios({
            method: "get",
            url: "/api/aulas/titulos-detalhe-conteudo",
            params: {
                aulaId: this.props.aulaId
            }
        })
            .then(response => {
                this.setState({
                    campoConteudos: response.data.conteudos,
                    campoHabilidades: response.data.habilidades,
                    campoMetodologia: response.data.metodologias,
                    campoAprendizagemMatutina: response.data.aprendizagemMatutina,
                    campoAprendizagemVespertina: response.data.aprendizagemVespertina
                });
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar a aula!");
            });
    };

    carregarHabilidadesBncc = () => {
        axios({
            method: "get",
            url: "/api/aulas/listar-bncc",
            params: {
                aulaId: this.props.aulaId
            }
        })
            .then(response => {
                this.setState({
                    bncc: response.data,
                    filteredData: response.data,
                    page: 2
                });
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar a bncc!");
            });
    };

    cancelarRascunho = () => {
        axios({
            method: "delete",
            url: "/api/aulas/rascunho",
            params: { aulaId: localStorage.getItem("aula_diario") }
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Rascunho descartado.");

                this.context.atualizarState({
                    existeRascunhoGuardado: false
                });
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error?.data?.message || "Não foi possível descartar o rascunho.");
            });
    };

    carregarRascunhoAula = (
        conteudoOriginal,
        conceitosOriginal,
        metodologiaOriginal,
        aprendizagemMatutinoOriginal,
        aprendizagemVespertinoOriginal
    ) => {
        const aulaId = localStorage.getItem("aula_diario");
        if (!aulaId) return;

        axios({
            method: "get",
            url: "/api/aulas/rascunho",
            params: { aulaId }
        })
            .then(response => {
                const {
                    conteudo_rascunho,
                    conceitos_rascunho,
                    metodologia_rascunho,
                    aprendizagem_matutino_rascunho,
                    aprendizagem_vespertino_rascunho,
                    dt_rascunho
                } = response.data;

                const existeRascunho =
                    conteudo_rascunho ||
                    conceitos_rascunho ||
                    metodologia_rascunho ||
                    aprendizagem_matutino_rascunho ||
                    aprendizagem_vespertino_rascunho;
                if (!existeRascunho) return; // não há nada salvo, sai direto

                // ✅ Normaliza valores do rascunho
                const rascunhoConteudo = conteudo_rascunho?.trim() || "";
                const rascunhoMetodologia = metodologia_rascunho?.trim() || "";
                const rascunhoAprendizagemMatutino = aprendizagem_matutino_rascunho?.trim() || "";
                const rascunhoAprendizagemVespertino = aprendizagem_vespertino_rascunho?.trim() || "";
                const rascunhoConceitos = conceitos_rascunho ? conceitos_rascunho.split(";").map(c => c.trim()) : [];

                // ✅ Normaliza valores originais
                const originalConteudo = conteudoOriginal?.trim() || "";
                const originalMetodologia = metodologiaOriginal?.trim() || "";
                const originalAprendizagemMatutino = aprendizagemMatutinoOriginal?.trim() || "";
                const originalAprendizagemVespertino = aprendizagemVespertinoOriginal?.trim() || "";
                const originalConceitos = Array.isArray(conceitosOriginal) ? conceitosOriginal.map(c => c.trim()) : [];

                // ✅ Função para comparar arrays ignorando ordem
                const arraysIguais = (arr1, arr2) => {
                    if (arr1.length !== arr2.length) return false;
                    const sorted1 = [...arr1].sort();
                    const sorted2 = [...arr2].sort();
                    return sorted1.every((val, idx) => val === sorted2[idx]);
                };

                const conteudoIgual = rascunhoConteudo === originalConteudo;
                const metodologiaIgual = rascunhoMetodologia === originalMetodologia;
                const aprendizagemMatutinoIgual = rascunhoAprendizagemMatutino === originalAprendizagemMatutino;
                const aprendizagemVespertinoIgual = rascunhoAprendizagemVespertino === originalAprendizagemVespertino;
                const conceitosIguais = arraysIguais(rascunhoConceitos, originalConceitos);

                // ✅ Se rascunho e original são idênticos → NÃO FAZ NADA
                if (conteudoIgual && metodologiaIgual && conceitosIguais && aprendizagemMatutinoIgual && aprendizagemVespertinoIgual) {
                    this.context.atualizarState({
                        existeRascunhoGuardado: false
                    });
                    return;
                }

                // ✅ Só mostra o modal se houver diferença real
                confirm({
                    title: "Rascunho encontrado",
                    content: `Existe um rascunho guardado para esta aula a ${moment(dt_rascunho).format(
                        "DD/MM/YYYY [às] HH:mm"
                    )}. Deseja carregar os dados do rascunho?`,
                    okText: "Sim, carregar",
                    cancelText: "Não",
                    onOk: () => {
                        this.setState({ bloquearAutoSave: true }, () => {
                            const conteudo = rascunhoConteudo;
                            const conceitos = rascunhoConceitos;
                            const metodologia = rascunhoMetodologia;
                            const aprendizagemMatutino = rascunhoAprendizagemMatutino;
                            const aprendizagemVespertino = rascunhoAprendizagemVespertino;

                            this.setState({ conteudo, conceitos, metodologia, aprendizagemMatutino, aprendizagemVespertino }, () => {
                                // ✅ Atualiza o Form também
                                this.props.form.setFieldsValue({
                                    conteudo,
                                    conceitos,
                                    metodologia,
                                    aprendizagemMatutino,
                                    aprendizagemVespertino
                                });

                                // Libera o autosave depois
                                this.setState({ bloquearAutoSave: false });
                            });
                        });
                    },
                    onCancel: this.cancelarRascunho
                });
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar rascunho!");
            });
    };

    apagarRascunhoAula = () => {
        axios({
            method: "delete",
            url: "/api/aulas/rascunho",
            params: {
                aulaId: this.props.aulaId
            }
        }).catch(error => {
            openNotificationWithIcon("error", "Erro", "Não foi possível apagar rascunho!");
        });
    };

    fetchMoreData = () => {
        this.setState({ loading: true });
        setTimeout(() => {
            let listaCampos = this.state.bncc;
            if (this.state.searchValue)
                listaCampos = this.state.bncc.filter(item =>
                    item.toLowerCase().split("-")[0].includes(this.state.searchValue.toLowerCase())
                );

            const newData = listaCampos.slice((this.state.page - 1) * 20, this.state.page * 20);
            if (newData.length > 0) {
                this.setState(prevState => ({
                    filteredData: [...prevState.filteredData, ...newData],
                    loading: false,
                    page: prevState.page + 1,
                    semMaisDados: newData.length < 20
                }));
            } else {
                this.setState(() => ({
                    loading: false,
                    semMaisDados: true
                }));
            }
        }, 1000);
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { TextArea } = Input;

        const entidadeId = localStorage.getItem("entidade_id");

        const {
            bncc,
            conteudo,
            conceitos,
            metodologia,
            aprendizagemMatutino,
            aprendizagemVespertino,
            campoConteudos,
            campoHabilidades,
            campoMetodologia,
            campoAprendizagemMatutina,
            campoAprendizagemVespertina,
            //LOADING
            iconLoading
        } = this.state;

        const { codigoMultisseriado } = this.props;

        const acesso = this.context.acessos?.find(x => x.func === 17);

        return (
            <>
                <Form className="form-categorias" layout="horizontal">
                    <div className="bloco">
                        {campoConteudos?.visivel && (
                            <Form.Item label={campoConteudos?.titulo}>
                                {getFieldDecorator("conteudo", {
                                    initialValue: conteudo
                                })(
                                    <TextArea
                                        name="conteudo"
                                        rows={4}
                                        style={{ height: 100 }}
                                        onChange={this.handleChange}
                                        disabled={!acesso?.update}
                                    />
                                )}
                            </Form.Item>
                        )}
                        {campoHabilidades?.visivel && (
                            <Form.Item label={campoHabilidades?.titulo}>
                                {getFieldDecorator("conceitos", {
                                    initialValue: conceitos,
                                    rules: [
                                        {
                                            required: entidadeId == 33,
                                            message: "Campo obrigatório"
                                        }
                                    ]
                                })(
                                    <Select
                                        key={localStorage.getItem("aula_diario")}
                                        mode="multiple"
                                        style={{ width: "100%" }}
                                        placeholder="Selecionar conceito"
                                        onChange={this.handleChangeSelect}
                                        onSearch={this.handleSearch}
                                        disabled={!acesso?.update}
                                        //onPopupScroll={this.handlePopupScroll}
                                    >
                                        {this.state.filteredData.map((item, index) => (
                                            <Option key={index} value={item}>
                                                {item}
                                            </Option>
                                        ))}
                                        {this.state.loading && (
                                            <Option key="loading" disabled>
                                                <Spin size="small" />
                                            </Option>
                                        )}
                                    </Select>
                                )}
                            </Form.Item>
                        )}
                        {campoMetodologia?.visivel && (
                            <Form.Item label={campoMetodologia?.titulo}>
                                {getFieldDecorator("metodologia", {
                                    initialValue: metodologia
                                })(
                                    <TextArea
                                        name="metodologia"
                                        rows={4}
                                        style={{ height: 100 }}
                                        onChange={this.handleChange}
                                        disabled={!acesso?.update}
                                    />
                                )}
                            </Form.Item>
                        )}
                        {campoAprendizagemVespertina?.visivel && (
                            <Form.Item label={campoAprendizagemVespertina?.titulo}>
                                {getFieldDecorator("aprendizagemVespertino", {
                                    initialValue: aprendizagemVespertino
                                })(
                                    <TextArea
                                        name="aprendizagemVespertino"
                                        rows={4}
                                        style={{ height: 100 }}
                                        onChange={this.handleChange}
                                        disabled={!acesso?.update}
                                    />
                                )}
                            </Form.Item>
                        )}
                        {campoAprendizagemMatutina?.visivel && (
                            <Form.Item label={campoAprendizagemMatutina?.titulo}>
                                {getFieldDecorator("aprendizagemMatutino", {
                                    initialValue: aprendizagemMatutino
                                })(
                                    <TextArea
                                        name="aprendizagemMatutino"
                                        rows={4}
                                        style={{ height: 100 }}
                                        onChange={this.handleChange}
                                        disabled={!acesso?.update}
                                    />
                                )}
                            </Form.Item>
                        )}
                    </div>
                    {acesso?.update && (
                        <div style={{ display: "flex", gap: 10 }}>
                            {codigoMultisseriado && (
                                <button
                                    className="botao-principal"
                                    onClick={() => this.guardarConteudoAula(true)}
                                    disabled={iconLoading}
                                    type="primary"
                                >
                                    {iconLoading ? <Icon type="loading" /> : null}
                                    Salvar Multisseriado
                                </button>
                            )}
                            <button
                                className="botao-principal"
                                onClick={() => this.guardarConteudoAula(false)}
                                disabled={iconLoading}
                                type="primary"
                            >
                                {iconLoading ? <Icon type="loading" /> : null}
                                Salvar
                            </button>
                        </div>
                    )}
                </Form>
            </>
        );
    }
}

const FormConteudos = Form.create({ name: "form-conteudos" })(Conteudos);

export default withRouter(FormConteudos);
